import React, { useState } from "react";

import { useTranslation } from 'react-i18next';

import PropTypes from "prop-types";

// @mui/icons-material
import Done from "@mui/icons-material/Done";
import Undo from "@mui/icons-material/Undo";
import Add from "@mui/icons-material/Add";
import Search from "@mui/icons-material/Search";
import Clear from "@mui/icons-material/Clear";

import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";

// core components

import { DataStatePage, DataStateModal, ModoModal, DialogOthelloResult, MessageOthelloBoxButtons } from "../othelloConstantes.jsx";
import { MensajeModalSegunEstado, ValidarPermisoOnLine } from "../othelloFunciones.jsx";
import OthelloMensaje from '../componentsothello/OthelloMensaje.jsx';

import Button from '../components/Button.jsx';


export default function OthelloBotonera({ ...props }) {

    const { statePage, arrayBotonesExtras, arrayBotonesCombo, cancelModoEliminar, forzarnuevo } = props;

    const { t } = useTranslation();

    const [stateModal, setstateModal] = useState(DataStateModal.dsClosed);
    const [modeModal, setmodeModal] = useState(ModoModal.SinDefinir);
    const [opencombo, setopencombo] = useState(false);
    const [anchor, setanchor] = useState(null);

    const [enabledbotones, setEnabledBotones] = useState(true);

    function doClickButton(callbackmethod, CurrentModoModal) {
        if (callbackmethod != null) {
            if (enabledbotones)
            {
                setEnabledBotones(false);

                var promise = new Promise(function (resolve, reject)
                {
                    //Si tiene el evento de pulsar el boton 
                    if (callbackmethod != null)
                    {
                        if (CurrentModoModal != null) {
                            setstateModal(DataStateModal.dsOpen);
                            setmodeModal(CurrentModoModal);
                        }
                        else
                            callbackmethod();

                    }                        

                    setTimeout(() => {
                        resolve(true);
                    }, 1000);
                });

                promise.then(result => {
                    setEnabledBotones(true);
                }, function (error) {
                    setEnabledBotones(true);
                });
            }
        }
    }

    const nuevoBoton = () => {
        //Si tiene el evento de pulsar el boton miramos si tiene permiso para realizar dicha accion
        if (props.onNuevo != null)
            doClickButton(props.onNuevo, null);
    }

    const grabarBoton = () => {
        //Si tiene el evento de pulsar el boton miramos si tiene permiso para realizar dicha accion
        if (props.onGrabar != null)
            doClickButton( props.onGrabar, null);
    }

    const cancelarBoton = () => {
        if (props.onCancel != null)
            doClickButton(props.onCancel, props.cancelModoEliminar != null && props.cancelModoEliminar ? ModoModal.Delete : ModoModal.Back);
    }

    const deshacerBoton = () => {
        if (props.onDeshacer != null)
            doClickButton(props.onDeshacer, ModoModal.Undo);
    }

    const buscarBoton = () => {
        if (props.onBuscar != null)
            doClickButton(props.onBuscar);
    }

    const onKeyDownBoton = (id, permiso) => {
        //Si tiene el evento de pulsar cualquier boton miramos si tiene permiso para realizar dicha accion
        if (props.onKeydown != null)
            props.onKeydown(id);
//            doClickButton(permiso, props.onKeydown, id, null, null);
    }

    const othelloModalResul = (modo, result, valor) => {

        //Si hemos recibido un true es que debemos realizar alguna operacion con los recibido (refrescar la pantalla, actual, añadir)
        if (result == DialogOthelloResult.OK) {
            //Si pulso el cancelar, quitamos el modal y ponemos la pantalla en modo busqueda
            if (modo == ModoModal.Back || (modo == ModoModal.Delete && props.cancelModoEliminar != null && props.cancelModoEliminar)) {
                props.onCancel();

                setstateModal(DataStateModal.dsClosed);
                setmodeModal(ModoModal.SinDefinir);
            }
            //Si pulso el deshacer, quitamos el modal y refrescamos los datos a los iniciales
            else if (modo == ModoModal.Undo) {
                setstateModal(DataStateModal.dsClosed);
                setmodeModal(ModoModal.SinDefinir);
                props.onDeshacer();
            }
            //sino, lo ponemos como cerrado, limpiamos en el modo en el que se abrio y ponemos la pagina en modo busqueda
            else {
                setstateModal(DataStateModal.dsClosed);
                setmodeModal(ModoModal.SinDefinir);
            }
        }
        //sino simplemente cerramos el modal
        else {
            setstateModal(DataStateModal.dsClosed);
        }
    }

    const opencomboClick = (event) => {
        setopencombo(!opencombo);
        setanchor(event.currentTarget);
    }

   
    const getBotonesActivos = (literal, statePage, cancelModoEliminar, forzarnuevo) => {
        let Botones = [];

        if (props.onGrabar != null && (statePage == null|| statePage != DataStatePage.dsSearch))
            Botones.push({ name: literal('_aceptar'), color: "success", icon: Done, click: grabarBoton });

        if (props.onCancel != null && (statePage == null || statePage != DataStatePage.dsSearch))
            Botones.push({ name: literal(cancelModoEliminar != null && cancelModoEliminar ? '_eliminar' : '_cancelar'), color: "error", icon: Clear, click: cancelarBoton });

        if (props.onDeshacer != null && (statePage == null || statePage != DataStatePage.dsSearch))
            Botones.push({ name: literal('_deshacer'), color: "warning", icon: Undo, click: deshacerBoton });

        if (props.onNuevo != null && (statePage == null || forzarnuevo || statePage == DataStatePage.dsDesconocido || statePage == DataStatePage.dsSearch))
            Botones.push({ name: literal('_nuevo'), color: "millenium", icon: Add, click: nuevoBoton });

        if (props.onBuscar != null)
            Botones.push({ name: literal('_buscar'), color: "info", icon: Search, click: buscarBoton });

        //{ name: "Eliminar", color: "danger", icon: Delete, click: deleteBoton },
        //{ name: "Nuevo", color: "primary", icon: Add, click: nuevoDataPage },

        return Botones;
    }

    let BotonesPagina = "";
    let BotonesExtras = "";
    let BotonesCombo = "";

    //Obtengo los botones que estan activos segun las propiedades recibidas
    let BotonesActivos = getBotonesActivos(t, statePage, cancelModoEliminar, forzarnuevo);

    //Obtenemos los botones de la pagina
    BotonesPagina = BotonesActivos.map((prop, key) => { return (<Button color={prop.color} size="small" variant="gradient" key={key} onClick={prop.click} /*disabled={prop.click == null}*/  ><prop.icon />&nbsp;{prop.name}</Button>); });

    //Si existe botones extras
    if (arrayBotonesExtras != null && arrayBotonesExtras.length > 0)
        BotonesExtras = arrayBotonesExtras.map((prop, key) => { return (<Button color="instagram" size="small" variant="gradient" key={prop.id} onClick={() => onKeyDownBoton(prop.id, prop.permiso)}><prop.icon />&nbsp;{prop.texto}</Button>); });

    //Si existe botones auxiliares
    if (arrayBotonesCombo != null && arrayBotonesCombo.length > 0) {

        let OpcionesCombo = arrayBotonesCombo.map((prop, key) => { return (<MenuItem onClick={() => onKeyDownBoton(prop.id, prop.permiso)}>{prop.icon != null ? <prop.icon /> : ""}&nbsp;{prop.texto}</MenuItem>); })

        if (OpcionesCombo != null && OpcionesCombo != "") {
            BotonesCombo = <div style={{ float: 'right' }}>
                <Button color="tumblr" size="small" onClick={opencomboClick}>{t("_masopciones")}</Button>
                <Menu
                    id="simple-menu"
                    keepMounted
                    open={opencombo}
                    onClose={opencomboClick}
                    anchorEl={anchor} >
                    {OpcionesCombo}
                </Menu>
            </div>
        }

    }

    let modal = "";

    //Si el estado del modal es distinto de cerrado
    if (stateModal != DataStateModal.dsClosed)
        modal = <OthelloMensaje tituloliteral="_atmovilidad" descrip={MensajeModalSegunEstado(modeModal, t)} modo={modeModal} open={stateModal} onCloseResulModal={othelloModalResul} botones={MessageOthelloBoxButtons.OKCancel} />
   
    return (<div style={{ backgroundColor: '#262626', color: '#ffffff', textAlign: 'justify', fontSize: 18, borderRadius: 3, marginTop: 5, marginBottom: 10, paddingTop: 8, boxShadow: "0 1px 4px 0 #c0c0c0" }}>
        <div style={{ backgroundColor: '#ffffff', paddingLeft: 15, paddingRight: 5, paddingTop: 6, paddingBottom: 6 }}>
            {BotonesPagina}
            {BotonesExtras}
            {BotonesCombo}
            {modal}   
        </div>
    </div>);
}

OthelloBotonera.propTypes = {
    statePage: PropTypes.object.isRequired,
    onNuevo: PropTypes.object,
    onGrabar: PropTypes.object,
    onDeshacer: PropTypes.object,
    onBuscar: PropTypes.object,
    onCancel: PropTypes.object,
    //KeyDown sobre los Botones extras y del combo de opciones
    //Ejemplo: {id:x, icon:x, texto: x, permiso: x}
    onKeydown: PropTypes.object,
    arrayBotonesExtras: [],
    arrayBotonesCombo: [],  
    cancelModoEliminar: PropTypes.string,
    forzarnuevo: PropTypes.bool

};

/*
import React, { Component } from 'react';

// nodejs library to set properties for components
import PropTypes from "prop-types";

// @mui/icons-material
import Done from "@mui/icons-material/Done";
import Undo from "@mui/icons-material/Undo";
import Add from "@mui/icons-material/Add";
import Search from "@mui/icons-material/Search";
import Clear from "@mui/icons-material/Clear";

// core components
import Button from "../components/Button.jsx";
import Grid from "@mui/material/Grid";

import { DataStatePage, DataStateModal, ModoModal } from "../othelloConstantes.jsx";
import { MensajeModalSegunEstado } from "../othelloFunciones.jsx";
import OthelloMensaje from '../componentsothello/OthelloMensaje.jsx';

export class OthelloBotonera2 extends Component 
{
    constructor(props) {
        super(props);
        this.state = {
            stateModal: DataStateModal.dsClosed,
            modeModal: ModoModal.SinDefinir
        };

        this.grabarBoton = this.grabarBoton.bind(this);
        this.cancelarBoton = this.cancelarBoton.bind(this);
        this.deshacerBoton = this.deshacerBoton.bind(this);        
        this.nuevoBoton = this.nuevoBoton.bind(this);   
        this.buscarBoton = this.buscarBoton.bind(this);
        this.othelloModalResul = this.othelloModalResul.bind(this);

        this.getBotonesActivos = this.getBotonesActivos.bind(this);  
    }

    nuevoBoton() {

        if (this.props.onNuevo != null)
            this.props.onNuevo();
    }

    grabarBoton() {
        this.props.onGrabar();
    }

    cancelarBoton() {       
        this.setState({ stateModal: DataStateModal.dsOpen, modeModal: ModoModal.Back });
    }

    deshacerBoton() {
        
        this.setState({ stateModal: DataStateModal.dsOpen, modeModal: ModoModal.Undo });
    }

    buscarBoton() {

        this.props.onBuscar();
    }
     

    othelloModalResul(modo, result, valor) {

        //Si hemos recibido un true es que debemos realizar alguna operacion con los recibido (refrescar la pantalla, actual, añadir)
        if (result) {
            //Si pulso el cancelar, quitamos el modal y ponemos la pantalla en modo busqueda
            if (modo == ModoModal.Back)
            {
                this.props.onCancel();
                this.setState({ stateModal: DataStateModal.dsClosed, modeModal: ModoModal.SinDefinir });
            }
            //Si pulso el deshacer, quitamos el modal y refrescamos los datos a los iniciales
            else if (modo == ModoModal.Undo)
            {
                this.setState({ stateModal: DataStateModal.dsClosed, modeModal: ModoModal.SinDefinir });
                this.props.onDeshacer();
            }           
            //sino, lo ponemos como cerrado, limpiamos en el modo en el que se abrio y ponemos la pagina en modo busqueda
            else
            {              
                this.setState({ stateModal: DataStateModal.dsClosed, modeModal: ModoModal.SinDefinir });
            }
        }
        //sino simplemente cerramos el modal
        else
            this.setState({ stateModal: DataStateModal.dsClosed });
    }

    getBotonesActivos(forzarnuevo)
    {
        let Botones = [];

        if (forzarnuevo && this.props.onNuevo != null)
            Botones.push({ name: "Nuevo", color: "primary", icon: Add, click: this.nuevoBoton });

        if (this.props.onGrabar != null)
            Botones.push({ name: "Aceptar", color: "success", icon: Done, click: this.grabarBoton });

        if (this.props.onCancel != null)
            Botones.push({ name: "Cancelar", color: "danger", icon: Clear, click: this.cancelarBoton });

        if (this.props.onDeshacer != null)
            Botones.push({ name: "Deshacer", color: "warning", icon: Undo, click: this.deshacerBoton });

        if (this.props.onBuscar != null)
            Botones.push({ name: "Buscar", color: "info", icon: Search, click: this.buscarBoton });

        //{ name: "Eliminar", color: "danger", icon: Delete, click: deleteBoton },        

        return Botones; 
    }
    
    render() {

        const { statePage, forzarnuevo } = this.props;

        let BotonesPagina = "";

         //Si estamos en modo busqueda solo debemos tener la opcion de añadir 
        if (statePage == DataStatePage.dsSearch && this.props.onNuevo != null) 
            BotonesPagina = (<Button color="primary" size="sm" onClick={this.nuevoBoton}><Add />Nuevo</Button>);        
        //sino, es que estamos editando, insertando etc, por tanto
        else
        {
            //Obtengo los botones que estan activos segun las propiedades recibidas
            let BotonesActivos = this.getBotonesActivos(forzarnuevo);

            //Obtenemos los botones de la pagina
            BotonesPagina = BotonesActivos.map((prop, key) => { return (<Button color={prop.color} size="sm" key={key} onClick={prop.click} ><prop.icon />{prop.name}</Button>); }); 
        }

        let modal = "";

        //Si el estado del modal es distinto de cerrado
        if (stateModal != DataStateModal.dsClosed)
            modal = <OthelloMensaje titulo="ATMovilidad" descrip={MensajeModalSegunEstado(modeModal)} modo={modeModal} open={stateModal} onCloseResulModal={this.othelloModalResul} />  

        return (<Grid container>
                    <Grid item xs={12} sm={12} >
                        {BotonesPagina}
                        {modal}
                    </Grid>
                </Grid>                              
          );

        
    }   
}

OthelloBotonera2.propTypes = {
    statePage: PropTypes.object.isRequired,  
    forzarnuevo: PropTypes.bool
    //onNuevo 
    //onGrabar
    //onBuscar
    //onDeshacer
};*/